<template>
<div>
    <el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" width="90%" :visible.sync="viewData.visible">
        <!-- <H3 style="text-align:center">
        <span v-if="dataForm.id">{{dataForm.projectName}}</span>
        <el-input v-else v-model="dataForm.projectName" size="small"></el-input>
    </H3> -->
        <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" size="small" label-width="0px" class="org-dialog-form">
            <el-tabs v-model="activeName" @tab-click="handChange">
                <el-tab-pane name="DesicdedSupplier" label="拟定点供应商" class="tab_style">
                    <div class="des_box">
                        <!-- <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                            <el-descriptions-item label="供应商编码:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="appartmentCode">
                                    <span>{{dataForm.rfqSupplierCode}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="供应商:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="appartmentCode">
                                    <span>{{dataForm.rfqSupplierName}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="供应商经验:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="rfqSupplierExpierence">
                                    <span>{{dataForm.rfqSupplierExpierence}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="供应商配额:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="rfqSupplyRadio">
                                    <span>{{dataForm.rfqSupplyRadio}} %</span>
                                </el-form-item>
                            </el-descriptions-item>
                            <el-descriptions-item label="备注:" :label-style="getStyle()" :content-style="getStyle2()">
                                <el-form-item style="margin-bottom: 0;" prop="remark" size="small">
                                    <el-input v-if="viewFlag !== 'view' && rfqAuditStatus === '提交审批单'" type="textarea" :rows="3" v-model="dataForm.remark" placeholder="备注"></el-input>
                                    <span v-else>{{dataForm.remark}}</span>
                                </el-form-item>
                            </el-descriptions-item>
                        </el-descriptions> -->
                        拟定点供应商报价
                        <el-table :data="priceList" row-key="id" size="small" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" class="mb15">
                            <el-table-column type="index" width="50" label="序号">
                                <!-- <template slot-scope="scope">
                                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                                </template> -->
                            </el-table-column>
                            <el-table-column prop="partCode" header-align="center" align="left" label="零件编码">
                            </el-table-column>
                            <el-table-column prop="partName" header-align="center" align="left" label="零件名">
                            </el-table-column>
                            <!-- <el-table-column prop="" header-align="center" align="right" label="配额">
                        </el-table-column>
                        <el-table-column prop="" header-align="center" align="right" label="相关客户产品">
                        </el-table-column> -->
                            <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格">
                            </el-table-column>
                            <!-- <el-table-column prop="workingEquipmentMoney" header-align="center" align="right" label="工装投入">
                            </el-table-column>
                            <el-table-column prop="amortizationMoney" header-align="center" align="right" label="摊销金额">
                            </el-table-column> -->
                            <!-- <el-table-column prop="totalCost" header-align="center" align="right" label="合计">
                            </el-table-column> -->
                            <el-table-column prop="targetCost" header-align="center" align="right" label="产品价格总计">
                                <template slot-scope="scope">
                                    {{fixedNumber(scope.row.targetCost)}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量">
                            </el-table-column>
                            <el-table-column prop="oneCarCost" header-align="center" align="right" label="产品单价">
                            </el-table-column>
                            <el-table-column prop="rfqSupplierName" header-align="center" align="right" label="供应商名称" width="200">
                            </el-table-column>
                            <el-table-column prop="rfqSupplyRadio" header-align="center" align="right" label="供应商配额">
                            </el-table-column>
                            <!-- <el-table-column v-if="viewFlag !== 'view'" header-align="center" align="left" width="70" label="操作">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="addOrUpdateRateHandle(scope.row.id)" icon="el-icon-edit">
                                        详细
                                    </el-button>
                                </template>
                            </el-table-column> -->
                            <!-- <el-table-column v-if="viewFlag !== 'view'" header-align="center" align="left" width="140" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="addOrUpdateRateHandle(scope.row.id)" icon="el-icon-edit">
                                    修改
                                </el-button>
                                <el-button type="text" size="small" @click="deleteRate(scope.row.id)" icon="el-icon-delete" class="button-danger">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column> -->
                        </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="PreparedSupplier" label="预选供应商" class="tab_style">
                    <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton') && viewFlag !== 'view'" type="primary" @click="addOrUpdateRateHandle()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                新增
            </el-button> -->
                    <!-- {{supplierSummaryList}} -->
                    <el-table :data="supplierSummaryList" row-key="id" size="small" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" class="mb15">
                        <el-table-column type="index" width="50" label="序号">
                        </el-table-column>
                        <el-table-column prop="rfqSupplierName" header-align="center" align="right" label="预选供应商">
                        </el-table-column>
                        <!-- <el-table-column prop="" header-align="center" align="right" label="相关客户产品">
                </el-table-column> -->
                        <!-- <el-table-column prop="" header-align="center" align="right" label="部件价格">
                </el-table-column> -->
                        <!-- <el-table-column prop="totalInvest" header-align="center" align="right" label="工装投入">
                        </el-table-column>
                        <el-table-column prop="amortizationMoney" header-align="center" align="right" label="摊销金额">
                        </el-table-column> -->
                        <el-table-column prop="totalCost" header-align="center" align="right" label="产品价格总计(汇总)">
                                <template slot-scope="scope">
                                    {{fixedNumber(scope.row.totalCost)}}
                                </template>
                        </el-table-column>
                        <el-table-column prop="targetPrice" header-align="center" align="right" label="目标价格">
                        </el-table-column>
                        <el-table-column prop="oneCarCount" header-align="center" align="right" label="单车用量">
                        </el-table-column>
                        <!-- <el-table-column prop="oneCarCost" header-align="center" align="right" label="单车成本">
                            <template slot-scope="scope">
                                {{ Number((scope.row.oneCarCount * scope.row.salePriceCost).toFixed(3))}}
                            </template>
                        </el-table-column> -->
                        <!-- <el-table-column v-if="viewFlag !== 'view'" header-align="center" align="left" width="140" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="addOrUpdateRateHandle(scope.row.id)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteRate(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column> -->
                    </el-table>
                </el-tab-pane>
                <el-tab-pane :key="3" label="附件文件" class="tab_style">
                    <!-- TODO:上传下载 产看 需求文档 -->
                    <FilesUpDown ref="filesUpDown" :bizId="dataForm.id" :bizType="FILE_BIZ_TYPE"></FilesUpDown>
                </el-tab-pane>
                <el-tab-pane :key="4" label="文件说明" class="tab_style">
                    <el-table :data="payList" row-key="id" size="small" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}" class="mb15">
                    <el-table-column type="index" width="50" label="序号">
                        <!-- <template slot-scope="scope">
                            {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                        </template> -->
                    </el-table-column>
                      <el-table-column prop="rfqSupplierName" header-align="center" align="right" label="供应商名称" width="200">
                      </el-table-column>
                        <el-table-column prop="payType" header-align="center" align="right" label="投入费用支付方式" width="200">
                            <template slot-scope="scope">
                            <el-select
                                    filterable
                                    v-model="scope.row.payType"
                                    clearable
                                    placeholder="请选择"
                                    style="width: 100%">
                                <el-option key="0" label="电汇/承兑"  :value="'0'" />
                                <el-option key="1" label="电汇"       :value="'1'" />
                                <el-option key="2" label="承兑"       :value="'2'" />
                                <el-option key="3" label="其他"       :value="'3'" />
                            </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column prop="payNode" header-align="center" align="right" label="费用支付节点及比例" width="400">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.payNode" placeholder="费用支付节点及比例"></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column prop="payTypeDes" header-align="center" align="right" label="备注" width="400">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.payTypeDes" placeholder="备注"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" v-if="subPayTypeVisible && this.dataForm.rfqAuditStatus =='提交审批单'" @click="subPayType()">
                提交文件说明
            </el-button>
            <el-button size="small" @click="viewData.visible = false">
                取消
            </el-button>
            <span v-for="(item,index) in auditData.taskActions" :key="index" style="margin-left: 10px;margin-right: 10px">
                <el-button size="small" v-if="item.taskName == '提交审批单'" plain type="primary" @click="goToApprove()" :loading="loading">
                    提交审批
                </el-button>
                <span v-if="item.flowRuleType && item.flowRuleType === 'action'">
                    <el-button type="success" size="small" plain @click="execApprove( item.taskId, item.flowRuleType, item.normalValue,true)" :loading="loading">通过
                    </el-button>
                    <el-button type="danger" size="small" plain @click="unQuote( item.taskId, item.flowRuleType, item.reverseValue)" :loading="loading">驳回
                    </el-button>
                </span>
            </span>
            <el-button v-if="isAuth('sourcing:audit:editbutton') && viewFlag !== 'view' && auditData.rfqAuditStatus === '流程结束' && rfqStatus != 7 && rfqStatus != 8" size="small" plain type="primary" @click="resultNotice()" :loading="loading">
                选定通知
            </el-button>
            <el-button v-if="isAuth('sourcing:audit:editbutton') && viewFlag !== 'view' && rfqStatus === '7'" size="small" plain type="primary" @click="createPriceAgreement()" :loading="loading">
                拟定价格协议
            </el-button>
            <!-- <el-button v-if="viewFlag !== 'view'" size="small" type="success" @click="dataFormPublish()">
                发布
            </el-button> -->
        </span>
    </el-dialog>

    <el-dialog :title="'提示'" width="30%" :close-on-click-modal="false" :visible.sync="unQuoteReasonFlag">
        <el-row>
            <el-form label-width="0px" :rules="dataRule2" :model="dataForm2" ref="dataForm2">
                <el-form-item prop="unQuoteReason">
                    <el-input type="textarea" :rows="10" placeholder="请输入驳回原因" maxlength="200" v-model="dataForm2.unQuoteReason">
                    </el-input>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row type="flex" justify="end">
            <el-button size="small" @click="unQuoteReasonFlag = false">取 消</el-button>
            <el-button size="small" plain type="primary" @click="UpdateBybohui()" :loading="loading">确 定</el-button>
        </el-row>
    </el-dialog>
</div>
</template>

<script>
import {
    auditList,
    getAuditSupplier,
    getAuditById,
    createAudit,
    editAudit,
    approve,
    resultNotice,
    createPriceAgreement,
    getPayType,
    setPayType,
} from '@/controller/audit'
import {
    getSupplierSummaryList
} from '@/controller/rfq'
import FilesUpDown from "@/views/common/file-up-down";
import moment from 'moment'
import {
    getLabelByValue
} from '@/utils/const'
import {
    setLoading,
    mapping
} from "@/utils/index";
// require('@/mock/mockProject');

export default {
    data() {
        return {
            FILE_BIZ_TYPE: 16,
            loading: false,
            rfqStatus: '',
            viewData: {
                visible: false,
                width: ''
            },
            initValue: {
            },
            activeName: 'DesicdedSupplier',
            priceList: [],
            payList:[],
            supplierSummaryList: [],
            disabled_flag: true,
            viewFlag: '',
            subPayTypeVisible: false,
            getLabelByValue: getLabelByValue,
            auditData: {},
            dataForm: {
                id: '',
                times: '',
                rfqSupplierCode: '',
                rfqSupplierName: '',
                rfqSupplierExpierence: '',
                rfqSupplyRadio: '',
                appartmentCode: '',
                appartmentName: '',
                rfqAuditStatus:'',
                carType: '',
                supplierId: '',
                rfqId: '',
                appartmentPrice: '',
                workingEquipmentMoney: '',
                amortizationMoney: '',
                totalCost: '',
                targetCost: '',
                oneCarCost: '',
                totalCarCost: '',
                unQuoteReason: '',
                rfqStatus: '',
                remark: '',
            },
            dataForm2: {
                unQuoteReason: ''
            },
            rfqSupplierId: '',
            rfqAuditStatus: '',
            dataRule: {
                // projectManagerId: [{
                //     required: true,
                //     message: '项目负责人名称不能为空',
                //     // trigger: 'blur'
                // }],
                // code: [{
                //     required: true,
                //     message: '组织代码不能为空',
                //     trigger: 'blur'
                // }],
                // tenantName: [{
                //     required: true,
                //     message: '请先在页面顶部导航栏选择租户',
                //     trigger: 'blur'
                // }]
            },
            dataRule2: {
                unQuoteReason: [{
                    required: true,
                    message: '驳回原因不能为空',
                    trigger: 'blur'
                }]
            },
            unQuoteReasonFlag: false,
        }
    },
    components: {
        FilesUpDown // 上传文件
    },
    mounted() {},
    methods: {
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("yyyy-MM-DD")
        },
        init(data, id, viewFlag) {
            // debugger
            console.log(data)
            this.viewFlag = viewFlag
            this.loading = false
            this.activeName = 'DesicdedSupplier'
            this.dataForm.id = id || 0;
            if (data) {
                this.rfqStatus = data.rfqStatus;
            }
            const times = data.times
            this.dimensionList = [];
            this.rateList = [];
            this.viewData.visible = true
            this.auditData = data
            this.rfqSupplierId = this.auditData.rfqSupplierId
            this.rfqAuditStatus = this.auditData.rfqAuditStatus
            this.$nextTick(() => {
                this.$refs.filesUpDown.init(this.viewFlag);
                this.$refs['dataForm'].resetFields()
                if (this.auditData && this.auditData.id) {
                    getAuditById({}, this.auditData.id).then(data => {
                        if (data && data.code === '00') {
                            mapping(this.auditData, this.dataForm)
                            mapping(data.body, this.dataForm)
                            //为了同步执行
                            getAuditSupplier({
                                rfqAuditId: this.dataForm.id
                            }).then(data => {
                                if (data && data.code === '00') {
                                    mapping(data.body, this.dataForm)
                                    this.dataForm.times = times
                                    this.dataForm.workflowId = this.auditData.workflowId;
                                    this.dataForm.unQuoteReason = this.auditData.unQuoteReason;
                                    this.dataForm.rfqStatus = this.rfqStatus
                                }
                            });
                            getPayType({
                                rfqAuditId: this.auditData.id,
                                rfqSupplierId: this.rfqSupplierId,
                                roundNo: times,
                                rfqId: this.auditData.rfqId
                            }).then(data => {
                                if (data && data.code === '00') {
                                    this.payList= data.body;
                                    console.log("@@@@"+JSON.stringify(this.payList));

                                }
                            });
                            auditList({
                                rfqAuditId: this.auditData.id,
                                rfqSupplierId: this.rfqSupplierId,
                                roundNo: times,
                                rfqId: this.auditData.rfqId
                            }).then(data => {
                                if (data && data.code === '00') {
                                    this.priceList = data.body;

                                }
                            });
                            console.log(this.dataForm.rfqId, 'this.dataForm.rfqId')
                            getSupplierSummaryList({
                                rfqId: this.auditData.rfqId,
                                roundNo: times
                            }).then(data => {
                                if (data && data.code === '00') {
                                    this.supplierSummaryList = []
                                    data.body.forEach(price => {
                                        console.log(price)
                                        if (price) {
                                            this.supplierSummaryList.push(price)
                                        }
                                    })
                                }
                            });
                        }
                    });

                }
            })

        },
        dataFormPublish() {
            this.dataForm.appartmentStatus = '1'
            this.dataFormSubmit()
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    // debugger
                    if (this.dataForm.id) {
                        editAudit(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        createAudit(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body ? data.body.id : '';
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        subPayType(){
            console.log(JSON.stringify(this.payList))
            var params={
                'payListss' : this.payList
            }
            setPayType(this.payList).then(data => {
                if (data && data.code === '00') {
                    this.$message({
                        message: '保存成功',
                        type: 'success',
                        onClose: () => {
                            this.$emit('refreshDataList')
                        }
                    })
                }
            });


        },
        goToApprove() {
            this.loading = true
            setLoading()
            let actions = this.auditData.taskActions;
            if (actions && actions.length > 0) {
                let action = actions[0];
                let params = {
                    id: this.auditData.id,
                    flowTaskId: action.taskId,
                    paramKey: action.flowType,
                    paramVal: action.val,
                    remark: this.dataForm.remark
                };
                approve(params).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            onClose: () => {
                                this.viewData.visible = false
                                this.loading = false
                                console.log('refreshDataList')
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.error("当前工作流未启动！不可提交审批")
                return
            }

        },
        execApprove(taskId, flowType, val, isPass) {
            this.loading = true
            setLoading()
            let text = "通过";
            if (!isPass) {
                text = "驳回";
            }
            this.$confirm(`确定进行${text}操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                approve({
                    'id': this.auditData.id,
                    'flowTaskId': taskId,
                    'paramKey': flowType,
                    'paramVal': val,
                    "unQuoteReason": this.dataForm2.unQuoteReason,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            onClose: () => {
                                this.loading = false
                                this.viewData.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
                this.viewData.visible = false;
            });
        },
        //驳回原因
        unQuote(taskId, flowRuleType, reverseValue) {
            this.dataForm.taskId = taskId
            this.dataForm.flowType = flowRuleType
            this.dataForm.paramVal = reverseValue
            this.dataForm2.unQuoteReason = ""
            this.unQuoteReasonFlag = true
            // execApprove(id, taskId, flowType, val,false)
        },
        // 确定驳回
        UpdateBybohui() {
            this.unQuoteReasonFlag = false;
            this.execApprove(this.dataForm.taskId, this.dataForm.flowType, this.dataForm.paramVal, false)
        },
        handChange(tab,event) {

            if(event.target.getAttribute('id')==='tab-3'&&this.viewFlag!='view'){
                this.subPayTypeVisible=true;
            }else{
                this.subPayTypeVisible=false;
            }
            // console.log(this.activeName, 'this.activeName')
            // if (this.activeName === 'PreparedSupplier') {
            //     getSupplierSummaryList({
            //         rfqId: this.dataForm.rfqId
            //     }).then(data => {
            //         if (data && data.code === '00') {
            //             this.supplierSummaryList = data.body;
            //         }
            //     });
            // }
        },
        //定厂定价通知
        resultNotice() {
            this.loading = true
            setLoading()
            let params = {
                'id': this.auditData.id
            }
            resultNotice(params).then(data => {
                if (data && data.code === '00') {
                    // this.dataForm = data.body;
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        onClose: () => {
                            this.viewData.visible = false
                            this.loading = false
                            this.$emit('refreshDataList')
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        //拟定价格协议
        createPriceAgreement() {
            this.loading = true
            setLoading()
            let params = {
                'id': this.auditData.id
            }
            createPriceAgreement(params).then(data => {
                if (data && data.code === '00') {
                    // this.dataForm = data.body;
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        onClose: () => {
                            this.viewData.visible = false
                            this.loading = false
                            this.$emit('refreshDataList')
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        getStyle() {
            return 'width: 100px; text-align: right'
        },
        getStyle2() {
            return 'width: 455.5px;'
        }
    },
}
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

form.el-form.org-dialog-form {
    width: 100%;
}

.linetext {
    white-space: pre-line;
}

.el-tabs__item {
    user-select: none;
}

.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}

.mb15 {
    margin-bottom: 15px;
}

.el-form-item__error {
    padding-top: 0;
}

.tab_style {
    min-height: 50vh;
}
</style>
